/**
 * MDP-577 / ER-11062 — refinement submit detection for IQ suggest-responsibilities.
 * A refinement is any follow-up message after IQ has already responded in the thread.
 */
export function isResponsibilitySuggestionRefinement(messages) {
  return Array.isArray(messages) && messages.some((message) => message.type === "ai");
}

/**
 * Whether unreviewed suggestion cards should be cleared before a regeneration stream starts.
 */
export function shouldClearUnreviewedSuggestionsOnRefinement({
  transcriptEnabled,
  overlayType,
  messages,
  unreviewedCount,
}) {
  return (
    transcriptEnabled === true &&
    overlayType === "roleResponsibility" &&
    isResponsibilitySuggestionRefinement(messages) &&
    unreviewedCount > 0
  );
}

/**
 * Whether the right pane should show the regeneration placeholder instead of suggestion cards.
 */
export function isAwaitingRegeneratedResponsibilitySuggestions({
  transcriptEnabled,
  overlayType,
  isSuggestionStreamActive,
  unreviewedCount,
  messages,
}) {
  return (
    transcriptEnabled === true &&
    overlayType === "roleResponsibility" &&
    isSuggestionStreamActive === true &&
    unreviewedCount === 0 &&
    isResponsibilitySuggestionRefinement(messages)
  );
}

/** Map get_suggestions role_responsibilities items to navigator card shape. */
export function mapRoleResponsibilitySuggestions(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.map((item) => ({
    name: item.responsibility_name,
    purpose: item.responsibility_purpose,
  }));
}
